export default {
  title: 'Ativos',

  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'menu.triggers': 'Automações',
  'menu.fields': 'Customizar campos adicionais',

  'fields.NAME': 'Nome',
  'fields.PLACE_NAME': 'Local/Pessoa/Frota',
  'fields.TYPE_NAME': 'Tipo',

  'menu.qrcode': 'Gerador de QR Code',
  'menu.buckets': 'Histórico de lotes de QR Code',

  'menu.linktree': 'Customizar menu de QR Code',
  name: 'Nome',
  type: 'Tipo',
  enabled: 'Ativado'
}
